import React from "react";
import WidgetsRenderRoot from "./widgets-render-root";
import WidgetInfo from "./widget-info";

const WidgetsRender = ({ data, location }) => {
    if (data === null || data === undefined || data.length === 0) return null;

    const widgets = data.filter((widget) => {
        const { renderLocation: widgetLocation } = WidgetInfo.get(widget);
        return location == widgetLocation;
    });

    if (widgets.length === 0) return null;

    return <WidgetsRenderRoot widgets={widgets} />;
};

export default WidgetsRender;
